import Grid from "@mui/material/Grid";
import React from "react";
import SectionTitle from "./SectionTitle";

export interface SectionHeaderProps {
    title: string;
    icon?: React.ReactNode;
    children?: React.ReactNode;
}

export default function SectionHeader(props: Readonly<SectionHeaderProps>) {
    const {title, icon, children} = props;

    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <Grid container alignItems={"center"} spacing={1}>
                        {icon && (
                            <Grid item xs={"auto"} sx={{padding: 0, display: "flex", alignItems: "center"}}>
                                {icon}
                            </Grid>
                        )}
                        <Grid item xs sx={{padding: 0}}>
                            <SectionTitle>{title}</SectionTitle>
                        </Grid>
                        <Grid item xs={"auto"} sx={{padding: 0}}>
                            {children}
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
}